import AuthenticationForm from "../client/components/AuthenticationForm";

function Signup() {
  return (
    <>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            className="mx-auto h-12 w-auto"
            src="/images/mm-logo.png"
            alt="Min Mave"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Opret en bruger
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            For at beskytte din konto benytter vi ikke passwords. Indtast din
            email nedenfor og du vil modtage en link til at oprette en konto og
            logge dig direkte ind.
          </p>
        </div>

        <AuthenticationForm buttonText="Kom i gang" />
      </div>
    </>
  );
}

export default Signup;
